import { camelizeKeys } from 'humps';

import { axios } from '../../../../services/axios';
import * as CONST from '../../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.TICKET_COMMETS_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.TICKET_COMMETS_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, camelizeKeys(response.data));
  } else {
    onFailed(dispatch, response.data);
  }
};

export const ticketCommentsList = (ticketId) => {
  return async (dispatch) => {
    dispatch({ type: CONST.TICKET_COMMETS_LIST_REQUEST });

    axios
      .get(`/tickets/${ticketId}/comments`)
      .then((response) => {
        handleResponse(dispatch, response);
      })
      .catch((error) => console.error(error));
  };
};
